const buildLendingOptions = (paymentDetails, obfuscatedCredit, selectedLoanTerm, vehicleCondition) => {
  const personalizedPayments = paymentDetails?.rates?.[obfuscatedCredit]?.paymentOffers?.[selectedLoanTerm] ?? [];
  if (personalizedPayments.length) {
    return personalizedPayments.map(_ref => {
      let {
        offeredBy,
        payment,
        ...rates
      } = _ref;
      return {
        name: offeredBy,
        rate: rates[vehicleCondition],
        payment
      };
    });
  }
  return [];
};
export { buildLendingOptions as default };
